import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { QuickStartGuideComponent } from './quick-start-guide.component';

export const ngxQuickStartGuideModule = angular.module('ngxQuickStartGuideModule', [])
	.directive('quickStartGuide', downgradeComponent({ component: QuickStartGuideComponent }))
	.name;
